import './S_Tab.scss';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Link } from '../../links/S_Link';

export type TabsSingleItemState = 'active' | 'passive' | 'active validated' | 'active error' | 'passive validated' | 'passive error';

interface IProps {
  text: string;
  link: string;
  callback?: () => void;
  state?: TabsSingleItemState;
  disabled?: boolean;
  tooltip?: string;
}

export const S_Tab = observer(
  (props: IProps): ReactElement => (
    <S_Link
      color='text'
      onClick={props.callback}
      to={props.link}
      className={classNames('tab-item', props.state, { disabled: props.disabled })}
      title={props.tooltip}
    >
      {props.text}
    </S_Link>
  )
);
